module.exports = __webpack_public_path__ + "120d009d49bc9a3202a4a4c7ceaa7215.svg";